import { render, staticRenderFns } from "./chat-audio-realtime-xunfei.vue?vue&type=template&id=236bd82d&scoped=true"
import script from "./chat-audio-realtime-xunfei.vue?vue&type=script&lang=js"
export * from "./chat-audio-realtime-xunfei.vue?vue&type=script&lang=js"
import style0 from "./chat-audio-realtime-xunfei.vue?vue&type=style&index=0&id=236bd82d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bd82d",
  null
  
)

export default component.exports